/* MapleWeld — header + homepage interactions (mwh.js)
   Self-contained. No dependencies. Safe to load site-wide. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  /* ---------- scroll reveal ---------- */
  function reveal() {
    var els = document.querySelectorAll('.mwh-rv, .mwh-stagger');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      each(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    each(els, function (el) { io.observe(el); });
  }

  /* ---------- count-up stats ---------- */
  function countUp() {
    var nodes = document.querySelectorAll('[data-mwh-count]');
    if (!nodes.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var raw = el.getAttribute('data-mwh-count') || '';
        var m = raw.match(/-?[\d.,]+/);
        if (!m) return;
        var target = parseFloat(m[0].replace(/,/g, ''));
        if (isNaN(target)) return;
        var prefix = raw.slice(0, m.index);
        var suffix = raw.slice(m.index + m[0].length);
        var dec = (m[0].split('.')[1] || '').length;
        var start = null, dur = 1400;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var v = target * (1 - Math.pow(1 - p, 3));
          el.textContent = prefix + v.toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + suffix;
          if (p < 1) requestAnimationFrame(step); else el.textContent = raw;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    each(nodes, function (n) { io.observe(n); });
  }

  /* ---------- sticky header state ---------- */
  function stickyHeader() {
    var h = document.querySelector('.mwh-header');
    if (!h || h.dataset.mwhStick === '1') return;
    h.dataset.mwhStick = '1';
    var ticking = false;
    function upd() { h.classList.toggle('is-stuck', window.pageYOffset > 12); ticking = false; }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(upd); }
    }, { passive: true });
    upd();
  }

  /* ==========================================================
     CATEGORY MEGA MENU
     Tier 1 tabs = categories, tier 2 rail = sub-categories,
     tier 3 = products, fetched on demand and cached in the DOM.
     Hover opens it; clicking anywhere on the trigger locks it open.
     ========================================================== */
  function megaMenu() {
    each(document.querySelectorAll('[data-mm-host]'), function (host) {
      if (host.dataset.mmReady === '1') return;
      host.dataset.mmReady = '1';

      var mm = host.querySelector('.mwh-mm');
      var trigger = host.querySelector('[data-mm-trigger]');
      if (!mm) return;

      var tabs = Array.prototype.slice.call(mm.querySelectorAll('[data-mm-tab]'));
      var panes = Array.prototype.slice.call(mm.querySelectorAll('[data-mm-pane]'));

      function loadPanel(panel) {
        if (!panel || panel.dataset.mmLoaded === '1' || panel.dataset.mmLoading === '1') return;
        var url = panel.getAttribute('data-mm-url');
        var slot = panel.querySelector('[data-mm-slot]');
        if (!url || !slot) return;
        panel.dataset.mmLoading = '1';
        fetch(url, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            slot.innerHTML = html;
            panel.dataset.mmLoaded = '1';
            panel.dataset.mmLoading = '';
            var frag = slot.querySelector('.mwh-mm__frag');
            var n = frag && frag.getAttribute('data-count');
            if (!n) return;
            var item = mm.querySelector('[data-mm-item="' + panel.getAttribute('data-mm-panel') + '"]');
            var badge = item && item.querySelector('[data-mm-count]');
            if (badge) { badge.textContent = n; badge.hidden = false; }
          })
          .catch(function () {
            panel.dataset.mmLoading = '';
            slot.innerHTML = '<p class="mwh-mm__empty">Could not load this sub-category. ' +
              '<a href="' + url.split('?')[0] + '">Open it instead</a>.</p>';
          });
      }

      function loadActiveIn(pane) {
        if (pane) loadPanel(pane.querySelector('[data-mm-panel].is-active'));
      }

      function showTab(key) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-mm-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var active = null;
        panes.forEach(function (p) {
          var on = p.getAttribute('data-mm-pane') === key;
          p.classList.toggle('is-active', on);
          if (on) active = p;
        });
        loadActiveIn(active);
      }

      tabs.forEach(function (t) {
        var key = t.getAttribute('data-mm-tab');
        var go = function () { showTab(key); };
        t.addEventListener('mouseenter', go);
        t.addEventListener('focus', go);
        t.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(); });
      });

      each(mm.querySelectorAll('[data-mm-item]'), function (it) {
        var key = it.getAttribute('data-mm-item');
        var pane = it.closest('[data-mm-pane]');
        if (!pane) return;
        var go = function () {
          each(pane.querySelectorAll('[data-mm-item]'), function (x) {
            x.classList.toggle('is-active', x === it);
          });
          var target = null;
          each(pane.querySelectorAll('[data-mm-panel]'), function (p) {
            var on = p.getAttribute('data-mm-panel') === key;
            p.classList.toggle('is-active', on);
            if (on) target = p;
          });
          loadPanel(target);
        };
        it.addEventListener('mouseenter', go);
        it.addEventListener('focus', go);
        it.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(); });
      });

      function prime() { loadActiveIn(mm.querySelector('[data-mm-pane].is-active')); }
      function open() {
        host.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        prime();
      }
      function close() {
        host.classList.remove('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }

      /* The whole trigger area toggles — not just the <a> — because the nav item
         is stretched to the full height of the header bar. Clicks inside the
         flyout itself are left alone so product links still navigate. */
      host.addEventListener('click', function (e) {
        if (mm.contains(e.target)) return;
        e.preventDefault();
        if (host.classList.contains('is-open')) close(); else open();
      });

      host.addEventListener('mouseenter', prime);
      host.addEventListener('focusin', prime);

      document.addEventListener('click', function (e) {
        if (host.classList.contains('is-open') && !host.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }

  /* ---------- search toggle ---------- */
  function search() {
    var btn = document.querySelector('[data-mwh-search-toggle]');
    var panel = document.querySelector('[data-mwh-search]');
    if (!btn || !panel || btn.dataset.mwhReady === '1') return;
    btn.dataset.mwhReady = '1';
    btn.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = panel.querySelector('input'); if (i) setTimeout(function () { i.focus(); }, 260); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) {
        panel.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- mobile drawer ---------- */
  function drawer() {
    var d = document.querySelector('[data-mwh-drawer]');
    var scrim = document.querySelector('[data-mwh-scrim]');
    if (!d || !scrim || d.dataset.mwhReady === '1') return;
    d.dataset.mwhReady = '1';
    function open() {
      d.classList.add('is-open'); scrim.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      d.setAttribute('aria-hidden', 'false');
    }
    function close() {
      d.classList.remove('is-open'); scrim.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      d.setAttribute('aria-hidden', 'true');
    }
    each(document.querySelectorAll('[data-mwh-drawer-open]'), function (b) { b.addEventListener('click', open); });
    each(document.querySelectorAll('[data-mwh-drawer-close]'), function (b) { b.addEventListener('click', close); });
    scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && d.classList.contains('is-open')) close();
    });
  }

  /* ---------- accordions (mobile menu) ---------- */
  function accordions() {
    each(document.querySelectorAll('.mwh-acc__head'), function (h) {
      if (h.dataset.mwhReady === '1') return;
      h.dataset.mwhReady = '1';
      h.addEventListener('click', function () {
        var acc = h.closest('.mwh-acc');
        if (!acc) return;
        h.setAttribute('aria-expanded', acc.classList.toggle('is-open') ? 'true' : 'false');
      });
    });
  }

  /* ---------- marquee duplication ---------- */
  function marquee() {
    each(document.querySelectorAll('.mwh-marquee'), function (m) {
      var track = m.querySelector('.mwh-marquee__track');
      var set = track && track.querySelector('.mwh-marquee__set');
      if (!track || !set || track.children.length >= 2) return;
      var clone = set.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
  }

  /* ---------- newsletter inline confirmation ---------- */
  function newsletter() {
    var p = new URLSearchParams(window.location.search);
    if (p.get('customer_posted') !== 'true') return;
    var ok = document.querySelector('[data-mwh-nl-ok]');
    if (ok) { ok.hidden = false; ok.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
  }

  function init() {
    marquee(); reveal(); countUp(); stickyHeader(); megaMenu(); search(); drawer(); accordions(); newsletter();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    marquee(); reveal(); countUp(); stickyHeader(); megaMenu(); search(); drawer(); accordions();
  });
})();
